<template>
  <div class="home">
    <div id="slogan">
      <p>KNOW YOUR GRAIN</p>
      <p>GROW YOUR BUSINESS</p>
    </div>

    <div id="logos">
      <ul>
        <li><img id="logo-image" src="../assets/logomark_white.png" /></li>
        <li>
          <img id="logo-text" src="../assets/grainsense_logo_white.png" />
        </li>
      </ul>

      <a href="https://www.grainsense.com" target="_blank"
        >www.grainsense.com</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'TrimPoster';
  src: url('../assets/fonts/TrimPoster-ExtraCompressed.ttf');
}

.home {
  margin: 0px;
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.4)
    ),
    url('../assets/background.jpg');
  background-position: center;
  background-size: cover;
}

#slogan {
  padding-top: 10vh;

  p {
    color: white;
    font-family: 'TrimPoster', 'adobe-garamond-pro', 'Georgia', 'Cambria',
      'Times New Roman', 'Times', serif;
    font-weight: normal;
    font-style: normal;
    letter-spacing: 0.01em;
    line-height: 0.9;
  }
}

#logos {
  position: absolute;
  bottom: 0px;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -20%);

  ul {
    list-style-type: none;
    padding: 0px;
  }

  a {
    color: white;
  }
}

@media screen and (min-width: 1200px) {
  #slogan {
    p {
      font-size: 6em;
    }
  }

  li {
    display: inline;
  }

  #logo-text {
    bottom: 20px;
    height: 100px;
  }

  #logo-image {
    bottom: 20px;
    height: 90px;
  }
}

@media screen and (max-width: 1200px) {
  #slogan {
    p {
      font-size: 3em;
    }
  }
  li {
    display: block;
  }
  #logo-text {
    bottom: 20px;
    height: 60px;
  }

  #logo-image {
    bottom: 20px;
    height: 130px;
  }
}
</style>
